import { Reducer } from "redux";


import { UserLogoutActionDispatchTypes } from "../constants/User";
import { UserLogoutResponse } from "../models/api/User";
import { UserLogoutActionTypes } from "../models/dispatchTypes/User";

const initialState: UserLogoutResponse = {
  loading: false,
  response: null,
  error: null,
};

const UserLogoutReducer: Reducer<
  UserLogoutResponse,
  UserLogoutActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case UserLogoutActionDispatchTypes.USER_LOGOUT_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case UserLogoutActionDispatchTypes.USER_LOGOUT_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case UserLogoutActionDispatchTypes.USER_LOGOUT_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case UserLogoutActionDispatchTypes.USER_LOGOUT_RESET: {
      return initialState;
    }
  }
  return state;
};

export default UserLogoutReducer;
